import { formValidationSchemaNoChanged } from '../../../../Form'
import {
  getRequestEditCategoryModalValidationSchema,
  isFormFieldsEqual,
} from '../../../../Request'

export function getRequestProfileHeaderEditCategoryValidationSchema(
  initialValues
) {
  return getRequestEditCategoryModalValidationSchema({
    initialValues,
  }).concat(
    formValidationSchemaNoChanged({
      initialValues,
      isEqual: isFormFieldsEqual,
    })
  )
}
